import styled from "styled-components";

export const Container = styled.div`
  grid-area: content;
 position: relative;
  background-color: ${props => props.theme.colors.silverBG};
  max-width: 100%; 
  height: calc(100dvh - 70px);
  min-height: 0;
  overflow-y: scroll;
  padding: 20px 20px 10px;

  @media (max-width: 1024px) {
     padding-top: 10px;
  }
`

export const Overlay = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  transition: opacity 0.3s ease;

  @media (min-width: 721px) {
    display: none;
  }
`;

export const SelectContainer = styled.div`
display: none;

@media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`